
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'

const prospectModule = namespace('prospect')
const authModule = namespace('auth')

@Component({
  components: {
    BaseCardContainer
  }
})
export default class ProspectParrainage extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @authModule.Action('getUserByCleAccesParrainageAction') getUserByCleAccesParrainage: any

  dataParrain = null
  error = null

  @Watch('prospect', {deep: true})
  watchProspect(val: any) {
    if (val.CLE_ACCES_PARRAIN) {
      this.onGetUserByCleAcces(val.CLE_ACCES_PARRAIN)
    }
  }

  get fullName() {
    const {civilite, nom, prenom} = this.dataParrain.utilisateurCopropriete.personne
    return `${civilite} ${prenom} ${nom}`
  }

  get email() {
    const {email} = this.dataParrain.utilisateurCopropriete.personne
    return email || null
  }

  get telephone() {
    const {telephone} = this.dataParrain.utilisateurCopropriete.personne
    return telephone || null
  }

  get mobile() {
    const {mobile} = this.dataParrain.utilisateurCopropriete.personne
    return mobile
  }

  mounted() {
    if (this.prospect && this.prospect.CLE_ACCES_PARRAIN) {
      this.onGetUserByCleAcces(this.prospect.CLE_ACCES_PARRAIN)
    }
  }

  onGetUserByCleAcces(cleAcces: any) {
    this.getUserByCleAccesParrainage({cleAcces}).then((response) => {
      if (response.status === 200) {
        this.dataParrain = response.data
      } else {
        this.error = response.data.message
      }
    })
  }
}
